var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import api from '@/shared/api';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useIntl } from 'react-intl';
import handleHttpError from '@/shared/services/HandleHttpError';
import DataCacheService from '@/shared/services/DataCacheService';
import { SettingsQueryKey } from './queryKey';
export var useUpdateCompanySettings = function () {
    var intl = useIntl();
    var queryClient = useQueryClient();
    var _a = useMutation(function (model) {
        return api.base.put('/api/settings/Company', model).then(function (res) { return res.data; });
    }, {
        onSuccess: function (result) {
            if (!result)
                return;
            var dataCacheCompany = DataCacheService.getCompanySettings(result.companyId);
            if (dataCacheCompany) {
                var updated = __assign(__assign({}, result), { sendInvoiceTemplateId: result.templateSendInvoice
                        ? result.templateSendInvoice.id
                        : null });
                Object.assign(dataCacheCompany, updated);
            }
            var defaultTaskResourceId = result.defaultTaskResourceId, taskTimeRegistrationMethod = result.taskTimeRegistrationMethod, sendInvoiceUseMailEditor = result.sendInvoiceUseMailEditor, forceLinkingDocumentsToRelation = result.forceLinkingDocumentsToRelation, useSharedAutomatedCustomerCodeSetup = result.useSharedAutomatedCustomerCodeSetup, useSharedAutomatedAccountingNrSetup = result.useSharedAutomatedAccountingNrSetup;
            var propagated = {
                defaultTaskResourceId: defaultTaskResourceId,
                taskTimeRegistrationMethod: taskTimeRegistrationMethod,
                sendInvoiceUseMailEditor: sendInvoiceUseMailEditor,
                forceLinkingDocumentsToRelation: forceLinkingDocumentsToRelation,
                useSharedAutomatedCustomerCodeSetup: useSharedAutomatedCustomerCodeSetup,
                useSharedAutomatedAccountingNrSetup: useSharedAutomatedAccountingNrSetup,
            };
            DataCacheService.updateAllCompanies(propagated);
            queryClient.setQueriesData([SettingsQueryKey.CompanySettings], function (old) {
                return old ? __assign(__assign({}, old), propagated) : old;
            });
            queryClient.setQueryData([SettingsQueryKey.CompanySettings, result.companyId], result);
        },
        onError: function (apiError) {
            handleHttpError(intl)(apiError);
        },
    }), mutateAsync = _a.mutateAsync, isLoading = _a.isLoading;
    return { updateCompanySettings: mutateAsync, isLoading: isLoading };
};
